'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var shelfItemShape = _react.PropTypes.shape({
  id: _react.PropTypes.number,
  metadataId: _react.PropTypes.string,
  shelf: _react.PropTypes.string,
  privateItem: _react.PropTypes.bool,
  dateAdded: _react.PropTypes.string
});

exports.default = shelfItemShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/shelfItemShape.js
// module id = 377
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16